var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_543_797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.34 17.58C11.43 17.67 11.52 17.73 11.64 17.79C11.76 17.85 11.88 17.85 12 17.85C12.12 17.85 12.24 17.82 12.36 17.79C12.48 17.73 12.57 17.67 12.66 17.58L19.23 11.01C19.59 10.65 19.59 10.05 19.23 9.69003C18.87 9.33003 18.27 9.33003 17.91 9.69003L12.93 14.67V0.960029C12.93 0.450029 12.51 0.0300293 12 0.0300293C11.49 0.0300293 11.07 0.450029 11.07 0.960029V14.64L6.09 9.69003C5.73 9.33003 5.13 9.33003 4.77 9.69003C4.41 10.05 4.41 10.65 4.77 11.01L11.34 17.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.07 15.99C22.56 15.99 22.14 16.41 22.14 16.92C22.14 19.77 19.83 22.08 16.98 22.08H7.05C4.2 22.08 1.89 19.77 1.89 16.92C1.89 16.41 1.47 15.99 0.96 15.99C0.45 15.99 0 16.41 0 16.92C0 20.79 3.15 23.97 7.05 23.97H16.98C20.85 23.97 24 20.82 24 16.92C24 16.41 23.58 15.99 23.07 15.99Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_543_797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.373ec460f271c699fe3b706abace65aa.svg";
export { ForwardRef as ReactComponent };